<!-- eslint-disable vue/no-v-html -->
<template>
	<div class="head-visual-fullwidth-container team-detail-slider">
		<div class="headvisual-slider__bg-image-bagde"></div>
		<div class="container">
			<div class="headvisual-slider container p-0">
				<div class="swiper-container swiper-content-slider">
					<div class="swiper-wrapper">
						<div class="col-lg-6 col-md-12 order-1 team-detail-hero-image">
							<div v-if="isLoading" class="loading-container">
								<div class="loading-spinner">
									<NuxtImg
										src="/images/logo.gif"
										width="80"
										height="80"
										class="mb-3"
									/>
								</div>
							</div>
							<NuxtImg
								:src="completeImageUrl(headvisual.PhotoUrl)"
                :alt="headvisual.PhotoMetadata['alt']"
                :title="headvisual.PhotoMetadata['title']"
								class="w-100"
								@load="imageLoaded"
                sizes="1360px"
							/>
						</div>
						<div class="col-lg-6 col-sm-8 col-10 order-1 position-relative">
							<h2 v-if="headvisual.Title" class="slide-text">
								<div v-html="headvisual.Title"></div>
							</h2>
							<h2 v-else class="slide-text">
								Kein Title vorhanden in der API !!!
							</h2>
							<div class="headvisual--content-subline">
								- {{ headvisual.Firstname }} -
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import Media from 'vue-media'
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
export default {
	name: 'TeamDetailHeadvisual',
	// components: {
	// 	Media
	// },
	// eslint-disable-next-line vue/require-prop-types
	props: ['headvisual'],
	data() {
		return {
			isLoading: true
		}
	},
	methods: {
		imageLoaded() {
			this.isLoading = false
		},
    completeImageUrl(imagePath) {
      if (!imagePath) {
        return '/images/no-image-placeholder.svg'
      }
      return usePimcoreAssetUrl(imagePath)
    }
	}
}
</script>

<style lang="scss" scoped>
.head-visual-fullwidth-container {
	position: relative;
	@include media-breakpoint-up(lg) {
		.headvisual-slider__bg-image-bagde {
			background-image: url('/images/badge-rund-black-green-idee.png');
			overflow: hidden;
			@include media-breakpoint-up(lg) {
				width: 260px;
				height: 260px;
				top: 340px;
				right: -70px;
			}
			width: 80px;
			height: 80px;
			position: absolute;
			top: 40px;
			right: -20px;
			background-size: contain;
			background-repeat: no-repeat;
		}
	}
}
.headvisual-slider {
	position: relative;
	margin-bottom: 10%;
	&.container {
		@include media-breakpoint-down(lg) {
			max-width: 100%;
		}
	}

	.team-detail-hero-image {
		min-height: 680px;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.swiper-container {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		overflow: hidden;
		position: relative;
		padding-top: 50px;
		@include media-breakpoint-down(lg) {
			padding-top: 20px;
		}
	}

	.swiper-slide {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		@include media-breakpoint-down(lg) {
			flex-direction: column-reverse;
			text-align: center;
		}
	}

	.slide-image {
		height: 85vh;
		width: 100%;
		object-fit: cover;
	}
	.slide-text {
		height: 100%;
		display: flex;
		align-items: center;
		line-height: 1;
		text-transform: uppercase;
		font-family: $font-family-crmtcs;
		@include font-size(65px);
		margin-bottom: 30px;
		text-align: center;

		@include media-breakpoint-up(lg) {
			@include font-size(100px);
			padding-left: 2rem;
			margin-left: -6rem;
			margin-bottom: 0;
			text-align: left;
		}
	}

	.headvisual--content-subline {
		text-align: center;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		margin: 0 auto;
		width: 100%;
		@include media-breakpoint-up(lg) {
			@include font-size(30px);
		}
		@include media-breakpoint-down(lg) {
			margin-top: 2rem;
		}
	}
}
.head-visual-fullwidth-container {
	position: relative;
	left: 50%;
	margin-left: -50vw;
	width: 100vw;
	background-position: top -10px right 0;
	background-repeat: no-repeat;
	z-index: 9999;
	background-size: contain;

	.container {
		position: relative;
	}
}
</style>
